import { mobileMaxWidth } from "../../_common/breakPoints";
import { getQueryParams, removeQueryParams, mergeQueryParams } from "../../_common/queryParams";
import { submitV2AnalyticsEvent } from "../utils/analyticsUtils";

const filter = `mblFilter`;
const getKey = ([key]) => key;
const nestedLayerClassPattern = /^filter-nested-list--lv-(\d+)$/;

const getSearchTerm = () => new URLSearchParams(window.location.search).get(`query`);

const deriveSelectOptItemAnalyticsProps = li => {
  const attributeType = li.parentElement && li.parentElement.dataset.parentFilter;
  const title = li.dataset && li.dataset.title;

  if (title) {
    const layerClass = li.classList && Array.from(li.classList).find(className => nestedLayerClassPattern.test(className));
    const layer = layerClass ? Number(layerClass.match(nestedLayerClassPattern)[1]) : null;
    return { searchTerm: getSearchTerm(), attributeType, selection: title, layer };
  }

  const labelText = li.querySelector(`.product-listing-filters__opt-label-text`);
  const selection = labelText && labelText.textContent && labelText.textContent.trim();
  return { searchTerm: getSearchTerm(), attributeType, selection, layer: null };
};

const deriveCompositeRangeAnalyticsProps = root => {
  const attributeType = root.dataset.filterType;
  const min = root.dataset.min;
  const max = root.querySelector(`.product-listing-filters__range-container__value`).value;
  return { searchTerm: getSearchTerm(), attributeType, selection: `${min}-${max}`, layer: null };
};

export function redirect(win, event) {
  if (event && event.stopPropagation) event.stopPropagation();
  const label = this.querySelector(`label`);
  const link = label.dataset.redirect;
  submitV2AnalyticsEvent(`applySearchFilters`, deriveSelectOptItemAnalyticsProps(this));
  if (mobileMaxWidth.matches) {
    const mblFilter = this.parentElement.dataset.parentFilter;
    win.location = `${link}&mblFilter=${win.encodeURIComponent(mblFilter)}`;
  } else {
    win.location = link;
  }
}


export function compositeRangeComputeUrl() {
  const root = this.closest(`.product-listing-filters__composite-range`);
  const value = root.querySelector('.product-listing-filters__range-container__value').value;
  const filterId = root.dataset.filterId;
  var redirectUrl = decodeURIComponent(root.dataset.applyFilterUrlRaw || '');
  redirectUrl = redirectUrl.replace(`{{${filterId}}}`,value);
  root.dataset.applyFilterUrl = redirectUrl;
  return redirectUrl;
}

export function compositeRangeRedirect(win) {
  const root = this.closest(`.product-listing-filters__composite-range`);
  compositeRangeValidate.apply(root.querySelector('.product-listing-filters__range-container__value'));
  const redirectUrl = compositeRangeComputeUrl.apply(root.querySelector('.product-listing-filters__range-container__value'));

  if (!this.closest('.validation-error')){
    submitV2AnalyticsEvent(`applySearchFilters`, deriveCompositeRangeAnalyticsProps(root));
    win.location = redirectUrl;
  }
}

export function compositeRangeValidate() {
  const root = this.closest(`.product-listing-filters__composite-range`);
  const val = parseFloat(this.value);
  const min = parseFloat(root.dataset.min);
  const max = parseFloat(root.dataset.max);

  if (isNaN(this.value) || val<min || val>max){
    root.classList.add('validation-error');
  }else{
    root.classList.remove('validation-error');
    compositeRangeComputeUrl.apply(this);
  }
}

export const openRefineWindow = (win, currentQuery = []) => {
  const mblFilter = currentQuery.filter(([key]) => key === filter)[0];
  if (mobileMaxWidth.matches && mblFilter) {
    const target = win.decodeURIComponent(mblFilter[1]);
    win.document.getElementById(`plp-filters-switch`).click();
    win.document.querySelector(`[data-filter-type='${target}'] span`).click();
  }
};

export function changeURL(win) {
  const currentQuery = getQueryParams(win);
  if (currentQuery.map(getKey).includes(filter)) {
    const updatedQuery = removeQueryParams(currentQuery, filter);
    win.history.replaceState({}, "", `${win.location.pathname}?${mergeQueryParams(updatedQuery)}`);
  }
}

export const initSideBarRedirect = win => {
  const currentQuery = getQueryParams(win);
  win.document.addEventListener(`MenuCloseEvent`, changeURL.bind(null, win));

  openRefineWindow(win, currentQuery);
  win.document.querySelectorAll(`.product-listing-filters__select-opt-item`).forEach(refineElement => {
    refineElement.addEventListener(`click`, redirect.bind(refineElement, win));
  });

  win.document.querySelectorAll(`.product-listing-filters__composite-range input`).forEach(refineElement => {
    refineElement.addEventListener(`change`, compositeRangeValidate.bind(refineElement, win));
  });

  win.document.querySelectorAll(`.product-listing-filters__composite-range .apply-btn > .apply`).forEach(refineElement => {
    refineElement.addEventListener(`click`, compositeRangeRedirect.bind(refineElement, win));
  });
};

export default initSideBarRedirect;
